"use strict";

exports.__esModule = true;
exports.Selector = void 0;
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _react = _interopRequireWildcard(require("react"));
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _MultiSelect = require("./MultiSelect");
var _SingleSelect = require("./SingleSelect");
var _excluded = ["className", "minimal", "shouldAddItemWhenNotInList", "style", "placeholder", "items", "getKey", "selected", "multiple", "itemPredicate", "renderItemText", "noResults", "children", "getTagProps", "onBlur", "usePortal", "tagInputProps", "disabled", "dataTestId", "position"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var MenuContainer = _styledComponents["default"].div.withConfig({
  displayName: "Selector__MenuContainer",
  componentId: "sc-w6vcu3-0"
})(["display:flex;width:auto;flex:0 1 auto;& .", ",& .", "{display:flex;flex:1;width:100%;> div{display:flex;flex:1;width:100%;}}"], _core.Classes.POPOVER_TARGET, _core.Classes.POPOVER_WRAPPER);
function createState(props) {
  var items = props.items,
    getItemCategory = props.getItemCategory;
  var collatedItems = items;
  if (typeof getItemCategory === "function") {
    var categories = new Set(items.map(getItemCategory));
    collatedItems = [];
    var _loop = function _loop() {
      var _collatedItems;
      var category = _step.value;
      (_collatedItems = collatedItems).push.apply(_collatedItems, items.filter(function (item) {
        return getItemCategory(item) === category;
      }));
    };
    for (var _iterator = _createForOfIteratorHelperLoose(categories), _step; !(_step = _iterator()).done;) {
      _loop();
    }
  }
  return {
    items: items,
    collatedItems: collatedItems
  };
}

/**
 * Allows a user to select item(s) from a list.
 */
var Selector = exports.Selector = /*#__PURE__*/function (_Component) {
  function Selector() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = createState(_this.props);
    _this.handleSelect = function (item, event) {
      if (event && event.keyCode === 13) {
        event.preventDefault();
        return;
      }
      var _this$props = _this.props,
        onSelect = _this$props.onSelect,
        toggle = _this$props.toggle,
        getKey = _this$props.getKey,
        multiple = _this$props.multiple,
        selected = _this$props.selected;
      var updated = [];
      var itemKey = getKey(item);
      if (multiple) {
        var found = false;
        for (var i = 0; i < selected.length; i++) {
          var selectedItem = selected[i];
          if (getKey(selectedItem) === itemKey || selectedItem === itemKey) {
            found = true;
            if (!toggle) {
              updated.push(selectedItem);
            }
          } else {
            updated.push(selectedItem);
          }
        }
        if (!found) {
          updated.push(item);
        }
      } else if (selected.length === 0 || !toggle || getKey(selected[0]) !== itemKey && selected[0] !== itemKey) {
        updated.push(item);
      }
      onSelect(updated);
    };
    _this.handleTagRemove = function (tag, index) {
      var _this$props2 = _this.props,
        selected = _this$props2.selected,
        onSelect = _this$props2.onSelect;
      var updated = selected.slice();
      updated.splice(index, 1);
      onSelect(updated);
    };
    _this.handleClear = function () {
      var onSelect = _this.props.onSelect;
      onSelect([]);
    };
    return _this;
  }
  _inheritsLoose(Selector, _Component);
  Selector.getDerivedStateFromProps = function getDerivedStateFromProps(props, prevState) {
    if ((0, _reactFastCompare["default"])(props.items, prevState.items)) {
      return null;
    }
    return createState(props);
  };
  var _proto = Selector.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var _this$props3 = this.props,
      className = _this$props3.className,
      minimal = _this$props3.minimal,
      shouldAddItemWhenNotInList = _this$props3.shouldAddItemWhenNotInList,
      style = _this$props3.style,
      placeholder = _this$props3.placeholder,
      _items = _this$props3.items,
      getKey = _this$props3.getKey,
      selected = _this$props3.selected,
      multiple = _this$props3.multiple,
      itemPredicate = _this$props3.itemPredicate,
      renderItemText = _this$props3.renderItemText,
      noResults = _this$props3.noResults,
      children = _this$props3.children,
      getTagProps = _this$props3.getTagProps,
      onBlur = _this$props3.onBlur,
      usePortal = _this$props3.usePortal,
      tagInputProps = _this$props3.tagInputProps,
      disabled = _this$props3.disabled,
      dataTestId = _this$props3.dataTestId,
      position = _this$props3.position,
      extra = _objectWithoutPropertiesLoose(_this$props3, _excluded);
    var collatedItems = this.state.collatedItems;
    var selectedItems = selected.length === 0 ? selected : selected.map(function (key) {
      return typeof key === "object" && key !== null ? key : lookup(collatedItems, getKey, key);
    });
    return /*#__PURE__*/_react["default"].createElement(MenuContainer, {
      "data-testid": dataTestId,
      style: style
    }, multiple ? /*#__PURE__*/_react["default"].createElement(_MultiSelect.MultiSelect, _extends({
      position: position,
      disabled: disabled,
      className: className,
      items: collatedItems,
      getKey: getKey,
      noResults: noResults,
      onItemSelect: this.handleSelect,
      renderItemText: renderItemText,
      itemPredicate: itemPredicate,
      popoverProps: {
        minimal: true,
        usePortal: usePortal,
        onClosing: onBlur
      },
      tagInputProps: Object.assign({
        tagProps: getTagProps,
        placeholder: placeholder,
        onRemove: this.handleTagRemove,
        rightElement: selectedItems.length > 0 ? /*#__PURE__*/_react["default"].createElement(_core.Button, {
          minimal: minimal,
          icon: _icons.IconNames.CROSS,
          onClick: this.handleClear
        }) : null,
        className: _core.Classes.LARGE,
        inputProps: {
          onKeyUp: function onKeyUp(event) {
            var keyCode = event.keyCode;
            var value = event.target.value;
            if (shouldAddItemWhenNotInList && (keyCode === 13 || keyCode === 188) && value && shouldAddItemWhenNotInList(value)) {
              // on pressing enter or comma
              if (keyCode === 188) {
                _this2.handleSelect(value.substring(0, value.length - 1));
              } else {
                _this2.handleSelect(value);
              }
            }
          }
        }
      }, tagInputProps),
      selected: selectedItems
    }, extra)) : /*#__PURE__*/_react["default"].createElement(_SingleSelect.SingleSelect, _extends({
      position: position,
      placeholder: selectedItems.length > 0 ? renderItemText(selectedItems[0]) : placeholder,
      minimal: minimal,
      disabled: disabled,
      style: style,
      items: collatedItems,
      getKey: getKey,
      itemPredicate: itemPredicate,
      noResults: noResults,
      onItemSelect: this.handleSelect,
      renderItemText: renderItemText,
      popoverProps: {
        minimal: true,
        usePortal: usePortal,
        onClosing: onBlur,
        boundary: "window"
      },
      selected: selectedItems
    }, extra), children));
  };
  return Selector;
}(_react.Component);
Selector.defaultProps = {
  minimal: false,
  usePortal: true,
  dataTestId: "Selector",
  style: {},
  rightIcon: _icons.IconNames.DOUBLE_CARET_VERTICAL,
  selected: [],
  multiple: false,
  toggle: true,
  getTagProps: function getTagProps() {
    return {};
  },
  tagInputProps: {},
  disabled: false,
  position: _core.Position.BOTTOM_LEFT
};
function lookup(items, getKey, key) {
  for (var i = 0; i < items.length; i++) {
    var item = items[i];
    if (getKey(item) === key) {
      return item;
    }
  }
  return key;
}